import {BASE_CITY, BASE_CITY_PREPOSITIONAL, BASE_CITY_ID, BASE_CITY_SELECTED_BY_USER, BASE_CITY_PHONE, CLEAR} from '../constants/BaseCity'

const initialState = {
  baseCityName: "",
  baseCityPrepositional: "во всех городах",
  baseCityID: "",
  baseCitySelectedByUser: false,
  baseCityPhone: ""
}

export default function baseCity(state = initialState, action) {
  switch (action.type) {
    case BASE_CITY :
      return { ...state, baseCityName: action.payload };
    case BASE_CITY_PREPOSITIONAL :
      return { ...state, baseCityPrepositional: action.payload }
    case BASE_CITY_ID :
      return { ...state, baseCityID: action.payload }
    case BASE_CITY_SELECTED_BY_USER:
      return {...state, baseCitySelectedByUser: action.payload};
    case BASE_CITY_PHONE :
      return { ...state, baseCityPhone: action.payload };
    case CLEAR :
      return initialState;
    default :
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/baseCity.js